import { Dto, DtoWithId } from "@mango/core";
import { Project } from "./project";
import { VerzendTarieven } from "./verzend-tarieven";


@Dto({fullName: "CIJBorculo.Logic.Pakbon"})
export class Pakbon extends DtoWithId {
	project: Project;
	pakbonnummer: number;
	datumPakbon: Date;
	verzendtarief: VerzendTarieven;
	verzendbedrag: number;
	opmerking: string;
	teFactureren: number;
	aantalPakbonregels:number;
	wachtOpPrijs:number;
	factuur: string;
	hasProFormaFactuur: boolean;
}